import React from "react";
import { axiosget } from "../../helpers/httprequest";
import swal from "../../helpers/swal";
import { useQueryClient } from "@tanstack/react-query";

const VerifyPayment = ({ v }) => {
  const [loading, setloading] = React.useState(false);
  const queryClient = useQueryClient();
  const _verify = async () => {
    try {
      setloading(true);
      const req = await axiosget(`ms_acceptance_fee_rrr/verify/${v?.acceptanceFee?.RRR}`);
      swal(req?.data?.type, req?.data?.message);
      if (req?.data?.type === "success") queryClient.invalidateQueries({ queryKey: ["acceptanceInformation"] });
      setloading(false);
    } catch ({ message }) {
      setloading(false);
    }
  };
  return (
    <button disabled={loading} className="btn btn-primary" onClick={_verify}>
      {loading ? (
        "Please wait..."
      ) : (
        <span>
          Verify Acceptance Fee Payment<i className="fa fa-pay"></i>
        </span>
      )}
    </button>
  );
};

export default VerifyPayment;
